export const API_ERROR = 'API_ERROR'
export const START_FETCH = 'START_FETCH'
export const STOP_FETCH = 'STOP_FETCH'
export const AUTHORIZED = 'AUTHORIZED'
export const UNAUTHORIZED = 'UNAUTHORIZED'
